import { render, staticRenderFns } from "./land.vue?vue&type=template&id=f075b176&scoped=true&"
import script from "./land.vue?vue&type=script&lang=js&"
export * from "./land.vue?vue&type=script&lang=js&"
import style0 from "./land.vue?vue&type=style&index=0&id=f075b176&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f075b176",
  null
  
)

export default component.exports